import { hasFlag } from 'country-flag-icons';

export function getCountryFlagCode(country?: string | null): string | undefined {
  if (!country) {
    return undefined;
  }

  const normalizedCountry = country.toUpperCase();

  return hasFlag(normalizedCountry) ? normalizedCountry : undefined;
}
